export const environment = {
  production: true,
  authWebsiteUrl: '%%authWebsiteUrl%%',
  cdnApiUrl: '%%cdnApiUrl%%',
  clientZoneApi: '%%clientZoneApi%%',
  authApiUrl: '%%authApiUrl%%',
  websocketAuthUrl: '%%websocketAuthUrl%%web-socket/login',
  websocketApiPath: '%%websocketApiPath%%',
  websocketHost: '%%websocketHost%%',
  cdnHost: '%%cdnHost%%',
  maxWarmCacheUrls: '%%maxWarmCacheUrls%%',
  maxPurgeUrls: '%%maxPurgeUrls%%',
  sentryDsn: '%%sentryDsn%%',
  sentryEnvName: '%%sentryEnvName%%',
  version: '@@version@@',
};
